import styles from "./CategoryBlock.module.scss";
import { CategoryCard, CategoryCardProps } from "./categoryCard/CategoryCard";

export type CategoryBlockProps = {
  title?: string;
  categoryCards: CategoryCardProps[];
};

export const CategoryBlock = ({ title, categoryCards }: CategoryBlockProps) => (
  <div>
    {title !== undefined && <h2 className={styles.title}>{title}</h2>}
    <div className={styles.cardsGrid}>
      {categoryCards.map((card) => (
        <CategoryCard key={card.title} {...card} />
      ))}
    </div>
  </div>
);
